import { mergeAttributes, Node } from "@tiptap/core";

export const ConditionNode = Node.create({
  name: "condition",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      variable: { default: "" },
      operator: { default: "" },
      value: { default: "" },
      _id: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "condition" }];
  },

  renderHTML({ HTMLAttributes }) {
    const { variable, operator, value } = HTMLAttributes;
    return [
      "condition",
      mergeAttributes(HTMLAttributes, { class: "condition-tag" }),
      `${variable} ${operator} ${value}`,
    ];
  },
});
